unit View.Certificados.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils;

type
  TFViewCertificadosList = class(TWebForm)
    btNew: TWebButton;
    CertificadosDataset: TXDataWebDataSet;
    CertificadosDatasetid: TIntegerField;
    CertificadosDatasetaliado_id: TIntegerField;
    CertificadosDatasetnumero_serie: TStringField;
    CertificadosDatasetdata_vencimento: TDateTimeField;
    CertificadosDatasetsenha: TStringField;
    CertificadosDatasetcertificado_s3: TStringField;
    CertificadosDatasetinclusao: TDateTimeField;
    CertificadosDatasetalteracao: TDateTimeField;
    WebDBTableControl1: TWebDBTableControl;
    WebDataSource: TWebDataSource;
    cbPageSize: TWebComboBox;
    edSearch: TWebEdit;
    lbPaginationInfo: TWebLabel;
    lcPaginator: TWebListControl;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TWebForm;
  end;

var
  FViewCertificadosList: TFViewCertificadosList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewCertificadosList }

procedure TFViewCertificadosList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewCertificadosList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TWebForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewCertificadosList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewCertificadosList, AElementID, Result, @AfterCreate);
end;

procedure TFViewCertificadosList.edSearchChange(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewCertificadosList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewCertificadosList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TWebButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      CertificadosDataset.Connection.Model.DefaultSchema.FindEntityType(CertificadosDataset.EntitySetName),
      CertificadosDataset.CurrentData
    );
    Button := TWebButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewCertificadosList.WebFormCreate(Sender: TObject);
begin
  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    CertificadosDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

end.
